import { AxiosRequestConfig } from 'axios';
import { BaseApiService } from './baseApiService';

export interface IClientCredentialsPaginated {
  Data: IClientCredential[];
  Pagination: IPagination;
}

export interface IClientCredential {
  clientID: string;
  clientSecret?: string;
  createdDate: string;
  expiresAt: string;
  id: string;
  isDeleted: boolean;
  issuedAt: string;
  organizationId: string;
  organizationName: string;
}

export interface IPagination {
  CurrentPage: number;
  NextPage: number;
  TotalPages: number;
  TotalRecords: number;
}

export interface ICreateClientCredentialRequest {
  createdDate: string;
  validMonthLength: number;
}

export interface ICreateClientCredentialResponse {
  clientID: string;
  clientSecret: string;
}

export interface IRotateClientSecretRequest {
  client_id: string;
}

export interface IRotateClientSecretResponse {
  clientID: string;
  clientSecret: string;
}

export class ClientCredentialsApiService extends BaseApiService {
  /**
   * Create a new client credential (API key)
   * POST /api/ClientCredentials
   */
  public async createAsync(createRequest: ICreateClientCredentialRequest): Promise<ICreateClientCredentialResponse> {
    return super.postAsync<ICreateClientCredentialRequest, ICreateClientCredentialResponse>(
      '/api/ClientCredentials',
      createRequest,
    );
  }

  /**
   * Rotate (regenerate) a client secret
   * POST /api/ClientCredentials/rotate-secret/{client_id}
   */
  public async rotateClientSecretAsync(
    rotateRequest: IRotateClientSecretRequest,
  ): Promise<IRotateClientSecretResponse> {
    const url = `/api/ClientCredentials/rotate-secret/${encodeURIComponent(rotateRequest.client_id)}`;
    return super.postAsync<{}, IRotateClientSecretResponse>(url, {});
  }

  /**
   * Delete a client credential by ID
   * DELETE /api/ClientCredentials/{id}
   */
  public async deleteItemAsync(id: string): Promise<void> {
    return super.deleteAsync(`/api/ClientCredentials/${id}`);
  }

  /**
   * Get paginated list of client credentials
   * GET /api/ClientCredentials?status={status}&pageNumber={pageNumber}&pageSize={pageSize}
   */
  public async getItems(status: number, pageNumber: number, pageSize: number): Promise<IClientCredentialsPaginated> {
    const config: AxiosRequestConfig = {
      params: { pageNumber, pageSize, status },
    };
    return super.getAsync<IClientCredentialsPaginated>('/api/ClientCredentials', config);
  }
}
